var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('H1',{staticClass:"has-text-white is-size-3 top40"},[_vm._v("404 PAGE NOT FOUND")]),_c('div',{staticClass:"has-text-light"},[_vm._v("The page you have requested does not exist. Please check the url and try again.")]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"limitWidth"},[_c('hr')])
}]

export { render, staticRenderFns }